module.exports = __webpack_public_path__ + "static/media/image-about-us-Tablet.1eb00bda.png";